var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZarabelt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.71 37.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f4f1f0;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.83,24.31l-.03-.07c-.4-.98-.98-1.85-1.71-2.61l-.25-.25-.04-.04,4.94-13.62,6.02,16.59h-8.94ZM48.49,18.14V1.29h3.85c5.14,0,7.85,3.05,7.85,8.83,0,6.14-1.56,8.02-6.66,8.02h-5.04ZM23.35,24.34l6.02-16.58,6.02,16.58h-12.04ZM86.39,36.72L72.49.07l-.02-.07h-.21l-7.68,21.16c-1.74-1.54-4.19-2.5-7.29-2.86l-.94-.1.94-.11c5.1-.92,8.54-4.14,8.54-8.02,0-5.32-5.01-9.04-12.18-9.04h-15.11v.27h4.34v27.06L32.1.03h-.2l-13.29,36.63h-.07c-.45.06-.9.09-1.34.09H6.49L27.45,1.03H2.03v10.96h.27c.05-5.34,3.16-10.69,10.02-10.69h8.69L0,37.02h27.76v-10.5h-.27c-.04,4.65-2.67,9.07-8.4,10.07l-.18.03,4.37-12.01h12.25l4.35,12.11h-4.27v.27h17.25v-.27h-4.36v-18.31h5.04c5.13,0,8.07,2.29,8.07,6.28v3.25c0,.36.03.88.05,1.32h0s-2.71,7.46-2.71,7.46h-3.54v.26h7.32v-.26h-3.5l2.47-6.77v.1s.07.61.07.61l.07.4c.41,2.5,1.37,4.34,2.84,5.46l.21.15c1.12.78,2.51,1.17,4.13,1.17,2.15,0,3.59-.54,4.77-1.8l-.16-.15c-1.09,1-2.01,1.42-3.15,1.42-1.96,0-2.98-2.37-2.98-4.71v-4.55c0-1.2-.17-2.31-.52-3.33l-.05-.14h8.97l4.36,12.14h-4.32v.26h14.77v-.26h-4.32Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZarabelt);
export default __webpack_public_path__ + "static/media/zarabelt.c2873af703f1cec0982fcff7404e47d9.svg";
export { ForwardRef as ReactComponent };